import { defineStore, acceptHMRUpdate } from 'pinia'
import { useUserStore } from '~/stores/user'
import { tr } from '~/assets/scripts/helpers'
import { useToast } from 'vue-toast-notification'

export const useVersionStore = defineStore('version', {
  state: () => ({
    currentVersion: useRuntimeConfig().public.APP_VERSION as string,
    latestVersion: null as string | null,
    isOutdated: false,
    outdatedSince: null as number | null,
    lastChecked: 0,
    initialLoad: Date.now(),
  }),
  actions: {
    initialize() {
      window.addEventListener('storage', (event) => {
        if (event.key === 'update_version' && event.newValue) {
          const version = event.newValue.split('-')[0] || ''
          const check_time = parseInt(event.newValue.split('-')[1] || '0')
          this.setVersion(version, check_time)
        }
      })

      setInterval(() => {
        this.checkVersion()
      }, 15_000)
    },
    checkVersion() {
      // Don't check if we already have a pending refresh
      if (this.isOutdated) {
        return
      }
      // Don't check API within the first 5 minutes of a tab being open
      if (Date.now() - this.initialLoad < 300_000) {
        return
      }
      // Don't check more often than once every minute
      if (Date.now() - this.lastChecked < 60_000) {
        return
      }
      // Don't check if logged out
      if (useUserStore().user === null) {
        return
      }

      try {
        const check_time = Date.now()
        $fetch('/version.txt', { query: { t: check_time } }).then((resp) => {
          const version = (resp as string).trim()
          localStorage.setItem('update_version', `${version}-${check_time}`)
          this.setVersion(version, check_time)
        })
      } catch (e) {
        console.error('Error fetching version', e)
      }
    },
    setVersion(version: string, lastChecked: number) {
      this.lastChecked = lastChecked
      this.latestVersion = version
      if (!this.currentVersion) {
        this.currentVersion = version
      }
      if (this.currentVersion !== this.latestVersion) {
        this.isOutdated = true
        // wait 10 minutes before showing the notification
        // typically a navigation event will happen first, which is way more seamless to the user
        setTimeout(() => {
          useToast({ position: 'bottom-right' }).warning(
            tr(
              'The application has been updated and needs to be reloaded - please refresh the page (F5)',
            )!,
            { duration: 0, dismissible: false },
          )
        }, 600_000)
      }
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useVersionStore, import.meta.hot))
}
